import React from 'react'
import { useTheme } from '@mui/material/styles'

import { TableSortLabel } from '@mui/material'
import { TextHeader } from '@abra/elements/table/headers'


const SortHeader = ({ handleClick, enableSortHeader, sortDirection, ..._textHeaderProps }) => {
  const theme = useTheme()
  return (
    <TableSortLabel
      active
      direction={_.lowerCase(sortDirection)}
      onClick={handleClick}
      sx={{
        '.MuiTableSortLabel-icon': {
          color: !!enableSortHeader && `${theme.palette.primary.main} !important`
        }
      }}
    >
      <TextHeader  {..._textHeaderProps} />
    </TableSortLabel>
  )
}

export default React.memo(SortHeader)
